import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';

import ArticleContent from '../../Molecules/ArticleContent';
import Popular from '../../Molecules/Popular';

import { IMainSectionProps } from './MainSection.definitions';

/** CSS import */
import Styles from './MainSection.module.scss';

const MainSection: React.FC<IMainSectionProps> = (props: IMainSectionProps) => {
  const { articleData, isReady, isFetching } = props;
  const { isDesktopView } = useGetViewType();

  return (
    <div className={Styles['wrapper']}>
      <ArticleContent
        isFetching={isFetching}
        articleData={articleData}
        isReady={isReady}
      />
      {isDesktopView && <Popular />}
    </div>
  );
};

export default MainSection;
